import React, { useState, useRef } from 'react';

import { updateOrganization } from '../../utils/api/organization_apis';
import { STATUS } from '../../utils/api/sharedfunction';
import { ORGANIZATION_COPY } from '../../constants/organizationCopy';
import ModalWrapper from '../ModalWrapper';
import { CommonFooter, FormSchemas, FormWrapper } from '../FormComponent';

const EditOrganizationModal = ({ open, onClose, organization, onSuccess, onError }) => {

  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  const handleFormSubmit = async () => {
    if (formRef.current) {
      await formRef.current.submit();
    }
  };
  const handleEditOrganization = async (data) => {
    try {
      setLoading(true);
      const { name, agentServiceUrl, mfaEnabled } = data;

      const response = await updateOrganization({
        id: organization.id,
        name,
        agentServiceUrl: agentServiceUrl || null,
        mfaEnabled,
      });

      if (response.status === STATUS.SUCCESS) {
        onSuccess();
        onClose();
      } else {
        const error = { 
          response: { 
            data: { 
              message: response.error,
              errors: response.errors 
            } 
          } 
        };
        onError(error);
      }
    } catch (error) {
      console.error('Error updating organization:', error);
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      label: 'Organization Name',
      required: true,
      placeholder: 'Enter organization name',
    },
    {
      name: 'agentServiceUrl',
      type: 'text',
      label: 'Agent Service URL',
      placeholder: 'Enter agent service URL',
      required: false,
    },
    {
      name: 'mfaEnabled',
      type: 'switch',
      label: ORGANIZATION_COPY.mfaEnabledLabel,
      required: false,
    },
  ];

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outline',
      className: 'primary',
      onClick: onClose,
      disabled: loading,
      loading
    },
    {
      label: 'Update',
      variant: 'primary',
      className: 'white bg-blue600',
      disabled: loading,
      loading,
      onClick: handleFormSubmit,
    },
    
  ];

  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      title="Edit Organization"
      size="small"
      footer={
        <CommonFooter
          buttons={buttons}
          align="right"
        />
      }
     children={
      <FormWrapper
        key={organization?.id || 'edit-org'}
        ref={formRef}
        schema={FormSchemas.organizationForm}
        fields={fields}
        onSubmit={handleEditOrganization}
        defaultValues={{
          name: organization?.name || '',
          agentServiceUrl: organization?.agent_service_url,
          mfaEnabled: organization?.mfa_enabled !== false,
        }}
        />
      }
    />
  );
};

export default EditOrganizationModal;
